import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from 'react-router-dom';
import {
  ArrowLeft,
  Phone,
  Mic,
  Bike,
  Copy,
  MapPin,
  CheckCircle,
  ArrowRight,
  Check,
  ChevronDown,
  ChevronUp,
  ShieldCheck,
  ArrowDown,
  HelpCircle,
  ClipboardList,
  ThumbsUp,
  Bell,
  Maximize2,
  Minimize2,
  BellOff,
  Shield,
  Clock,
  StickyNote,
  Timer,
} from "lucide-react";

import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import banner1 from "../Assets/banner_1.webp";
import banner2 from "../Assets/banner_2.webp";
import item1 from "../Assets/milk.jpg";
import item2 from "../Assets/bread.jpg";
import driver from "../Assets/driver.jpg";
import home from "../Assets/Home_icon.svg";
import resturant from "../Assets/Resturant_icon.svg";
import deliveryman from "../Assets/delivery man 512 x 512.svg";
import { toast } from "sonner";
import "../App.css";
import axios from "axios";
import * as signalR from "@microsoft/signalr";

function MapResizer() {
  const map = useMap();
  useEffect(() => {
    const timeout = setTimeout(() => {
      map.invalidateSize();
    }, 100);
    return () => clearTimeout(timeout);
  }, [map]);
  return null;
}

function FitBounds({ bounds }) {
  const map = useMap();

  useEffect(() => {
    if (!bounds || bounds.length === 0) return;
    map.fitBounds(bounds, { padding: [30, 30] });
  }, [bounds, map]);

  return null;
}

export default function OrderTracking() {
  const images = [banner1, banner2];

  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [showSafety, setShowSafety] = useState(false);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const lastScrollY = useRef(0);
  const mapRef = useRef(null);
  const [expand, setExpand] = useState(false);
  const [manualExpand, setManualExpand] = useState(false);
  const baseImages = [banner1, banner2];

  const [baseurl] = useState("https://api2.packky.com");
  const username = "packky@gmail.com";
  const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";
  const token = btoa(`${username}:${password}`);

  const [driverLoading, setDriverLoading] = useState(false);
  const [isUnauthorised, setIsUnauthorised] = useState(false);
  const [driverApiData, setDriverApiData] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);

  const [trackerUrl, setTrackerUrl] = useState(null);
  const [trackId, setTrackId] = useState(null);
  // ❌ const [taskId, setTaskId] = useState(null); // YEH LINE HATAO
  const [orderId, setOrderId] = useState(null);
  const [deliveryInstruction, setDeliveryInstruction] = useState(null);
  const [instructionOpen, setInstructionOpen] = useState(false);

  // 🎯 URL se taskId extract karo
  const params = useParams();
  const fullParam = params.taskId || window.location.pathname.split('/').filter(Boolean).pop();
  const taskId = fullParam ? fullParam.split('-')[0] : null;

  const [driverPosition, setDriverPosition] = useState(null);
  const [routePath, setRoutePath] = useState([]);
  const [rotation, setRotation] = useState(0);
  const prevPositionRef = useRef(null);

  // 🔍 DEBUG - Check karo taskId mil raha hai ya nahi
  // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━");
  // console.log("🌐 Current URL:", window.location.href);
  // console.log("📍 Pathname:", window.location.pathname);
  // console.log("🔍 useParams() result:", params);
  // console.log("📦 fullParam:", fullParam);
  // console.log("✅ Final taskId:", taskId);
  // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━");
  // const [routePath, setRoutePath] = useState([]);
  // const [rotation, setRotation] = useState(0);
  // const prevPositionRef = useRef(null);
(async function testSignalR() {
  console.clear();
  // console.log("🚀 SignalR Debugging Started...\n");

  // Configuration
  const baseurl = "https://api2.packky.com";
  const username = "packky@gmail.com";
  const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";
  const token = btoa(`${username}:${password}`);
  const taskId = "8380"; // Your current taskId

  // console.log("📋 Configuration:");
  // console.log("   Base URL:", baseurl);
  // console.log("   TaskId:", taskId);
  // console.log("   Token:", token.substring(0, 20) + "...");
  // console.log("\n━━━━━━━━━━━━━━━━━━━━━━━━━\n");

  // Check if SignalR is available
  if (typeof signalR === "undefined") {
    // console.error("❌ SignalR library not found!");
    // console.log("💡 Make sure @microsoft/signalr is loaded in your app");
    return;
  }

  // console.log("✅ SignalR library loaded\n");

  // Create connection
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${baseurl}/notificationHub`, {
      accessTokenFactory: () => token,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Debug) // Changed to Debug for more details
    .build();

  // Connection events
  connection.onreconnecting((error) => {
    // console.log("🔄 Reconnecting...", error?.message);
  });

  connection.onreconnected((connectionId) => {
    // console.log("✅ Reconnected! Connection ID:", connectionId);
  });

  connection.onclose((error) => {
    // console.log("❌ Connection Closed:", error?.message);
  });

  // Listen to ReceiveStatusUpdate
  connection.on("ReceiveStatusUpdate", (data) => {
    // console.log("\n━━━━━━━━━━━━━━━━━━━━━━━━━");
    // console.log("🔔 SIGNALR MESSAGE RECEIVED!");
    // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━\n");
    
    // console.log("📦 Raw Data:");
    // console.log(JSON.stringify(data, null, 2));
    
    // console.log("\n📊 Data Analysis:");
    // console.log("   Type:", typeof data);
    // console.log("   Is Array:", Array.isArray(data));
    // console.log("   Length:", Array.isArray(data) ? data.length : "N/A");
    
    // Convert to array if not already
    const items = Array.isArray(data) ? data : [data];
    
    items.forEach((item, index) => {
      // console.log(`\n🔍 Item ${index + 1}:`);
      // console.log("   TaskId (SignalR):", item.taskId, `(${typeof item.taskId})`);
      // console.log("   Current TaskId:", taskId, `(${typeof taskId})`);
      // console.log("   Strict Match (===):", item.taskId === taskId);
      // console.log("   Loose Match (==):", item.taskId == taskId);
      // console.log("   String Match:", String(item.taskId) === String(taskId));
      
      if (item.latitude && item.longitude) {
        // console.log("   📍 Position:", [item.latitude, item.longitude]);
      } else {
        // console.log("   ⚠️ No coordinates in this update");
      }
      
      if (item.message) {
        // console.log("   💬 Message:", item.message);
      }
      
      if (item.status) {
        // console.log("   📊 Status:", item.status);
      }
      
      console.log("\n   🗂️ All Fields:");
      Object.keys(item).forEach(key => {
        // console.log(`      ${key}:`, item[key]);
      });
    });
    
    // console.log("\n━━━━━━━━━━━━━━━━━━━━━━━━━\n");
  });

  // Try to connect
  try {
    await connection.start();
    // console.log("✅ SignalR Connected Successfully!");
    // console.log("🎧 Listening for 'ReceiveStatusUpdate' events...");
    // console.log("📍 Waiting for driver movement updates...\n");
    // console.log("💡 TIP: Open driver app and move to see updates\n");
    // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━\n");
    
    // Keep connection alive
    // console.log("⏳ Connection is active. Waiting for messages...");
    // console.log("🛑 To stop, run: window.testConnection.stop()\n");
    
    // Store connection globally so you can stop it
    window.testConnection = connection;
    
  } catch (error) {
    console.error("❌ Connection Failed:", error);
    // console.log("\n🔍 Possible Issues:");
    // console.log("   1. Check if API URL is correct");
    // console.log("   2. Verify authentication token");
    // console.log("   3. Check network connection");
    // console.log("   4. Check CORS settings");
  }
})();

// ==========================================
// 📝 HELPER COMMANDS
// ==========================================

// console.log("\n📌 Useful Commands:");
// console.log("━━━━━━━━━━━━━━━━━━━━━━━━━");
// console.log("🛑 Stop connection:");
// console.log("   window.testConnection.stop()");
// console.log("\n🔄 Check connection state:");
// console.log("   window.testConnection.state");
// console.log("\n📊 Connection states:");
// console.log("   0 = Disconnected");
// console.log("   1 = Connected");
// console.log("   2 = Connecting");
// console.log("   4 = Reconnecting");
// console.log("━━━━━━━━━━━━━━━━━━━━━━━━━\n");

  const loopedImages = Array.from({ length: 40 }, (_, i) => {
    return baseImages[i % baseImages.length];
  });

  const iconMap = {
    Bike: <Bike size={18} />,
    MapPin: <MapPin size={18} />,
    Phone: <Phone size={18} />,
    note: <StickyNote size={20} />,
    shield: <Shield size={18} />,
    bellOff: <BellOff size={18} />,
    phone: <Phone size={18} />,
    mapPin: <MapPin size={18} />,
    clock: <Clock size={18} />,
  };

  const driverStatus = driverApiData?.driver_status?.toLowerCase();

  const driverData = {
    name: driverApiData?.driver_name || "Delivery Partner",
    image: driverApiData?.profile_photo || driver,
    phone: driverApiData?.driver_mobile_number || "9876543210",

    latitude: driverApiData?.drvier_latitude
      ? Number(driverApiData.drvier_latitude)
      : null,

    longitude: driverApiData?.driver_longitude
      ? Number(driverApiData.driver_longitude)
      : null,

    message:
      driverStatus === "successful"
        ? "On the way to your location"
        : "Waiting for assignment",

    statusColor:
      driverStatus === "successful" ? "text-green-600" : "text-gray-500",
  };

  const fetchDriver = async () => {
    // console.log(" fetchDriver called with taskId:", taskId);
    
    if (!taskId) {
      // console.log(" taskId nahi hai, API call nahi hoga");
      return;
    }

    // console.log(" taskId mil gaya, API call kar rahe hain...");
    
    setDriverLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDeliveryPartnerDetails`,
        { taskId },
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );

      // console.log(" Driver API Response:", res.data);

      if (res?.data?.responseCode === "00") {
        setDriverApiData(res.data.data);
        // console.log(" Driver data set ho gaya");
      } else if (res?.data?.responseCode === "401") {
        setIsUnauthorised(true);
        // console.log(" Unauthorised");
      } else {
        toast.error(res?.data?.responseMessage || "Failed to fetch driver");
        // console.log(" Error:", res?.data?.responseMessage);
      }
    } catch (error) {
      console.error(" Driver API error", error);
      toast.error("Error fetching driver");
    } finally {
      setDriverLoading(false);
    }
  };

  const fetchDriverTracker = async () => {
    if (!orderId) return; // orderId chahiye hoga

    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v2.0/driverTracker`,
        { orderid: orderId },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res?.data?.responseCode === "00") {
        const tracker = res.data.data?.[0];
        if (tracker?.url) {
          setTrackerUrl(tracker.url);
          setTrackId(tracker.trackId);
        }
      }
    } catch (err) {
      console.error("driverTracker API error", err);
    }
  };

  const fetchResturantDetails = async () => {
    if (!taskId) return;

    try {
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getRestaurantOrderDetails`,
        { taskId },
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );

      if (res?.data?.responseCode === "00") {
        setOrderDetails(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch order details");
    }
  };

  const fetchOrderDetails = async () => {
    if (!trackId) return;

    try {
      const res = await fetch("https://api2.packky.com/orderdetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          trackId: trackId,
        }),
      });

      const result = await res.json();

      if (result.responseCode === "00") {
        const orderData = result.data;

        setOrderId(orderData.order_id);
        setTotal(orderData.total);

        const parsedDetails = JSON.parse(orderData.order_details);

        const formattedProducts = parsedDetails.items.map((item, index) => ({
          id: index + 1,
          name: item.itemName,
          qty: Number(item.quantity),
          price: Number(item.unitPrice),
          image: "/placeholder.png",
        }));

        setProducts(formattedProducts);
      }
    } catch (error) {
      console.error("Order details fetch error:", error);
    }
  };

  const fetchDeliveryInstructions = async () => {
    try {
      const res = await axios.post(
        `${baseurl}/api/Task/v1.0/getDeliveryInstruction`,
        { status: "Y" },
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );

      if (res?.data?.responseCode === "00") {
        const list = res.data.data || [];

        const mappedData = {
          header: {
            icon: "note",
            title: list[0]?.title || "Delivery Instructions",
            subtitle:
              list[0]?.description ||
              "Customer's special instructions for the delivery partner",
          },
          sections: list.map((item) => ({
            id: item.pk_instruction_id,
            icon: "shield",
            title: item.title,
            description: item.description,
          })),
        };

        setDeliveryInstruction(mappedData);
      }
    } catch (err) {
      console.error("Delivery instruction API error", err);
    }
  };

  const prevPosRef = useRef(null);

  useEffect(() => {
    if (driverApiData?.drvier_latitude && driverApiData?.driver_longitude) {
      const currentPos = [
        Number(driverApiData.drvier_latitude),
        Number(driverApiData.driver_longitude),
      ];

      // console.log("CURRENT POSITION:", currentPos);

      if (prevPosRef.current) {
        const moved =
          prevPosRef.current[0] !== currentPos[0] ||
          prevPosRef.current[1] !== currentPos[1];

        console.log(moved ? "DRIVER MOVED" : "DRIVER NOT MOVED (STATIC)");
      }

      prevPosRef.current = currentPos;
      setDriverPosition(currentPos);
    }
  }, [driverApiData]);

  // Initial load - jab taskId mil jaye
  useEffect(() => {
    // console.log("🔄 useEffect triggered for taskId:", taskId);
    
    if (taskId) {
      // console.log("✅ taskId available, calling APIs...");
      fetchDriver();
      fetchResturantDetails();
    } else {
      // console.log("❌ taskId nahi mila, APIs call nahi hongi");
    }
  }, [taskId]);

  // Jab orderId mil jaye tab tracker fetch karo
  useEffect(() => {
    if (orderId) {
      fetchDriverTracker();
    }
  }, [orderId]);

  // Jab trackId mil jaye tab order details fetch karo
  useEffect(() => {
    if (trackId) {
      fetchOrderDetails();
    }
  }, [trackId]);

  // Delivery instructions - static data
  useEffect(() => {
    fetchDeliveryInstructions();
  }, []);

  useEffect(() => {
    if (!driverPosition) return;

    setRoutePath((prev) => {
      const last = prev[prev.length - 1];
      if (
        last &&
        last[0] === driverPosition[0] &&
        last[1] === driverPosition[1]
      ) {
        return prev;
      }
      return [...prev, driverPosition];
    });
  }, [driverPosition]);

  const openTracker = () => {
    if (!trackerUrl) {
      toast.error("Tracking not available yet");
      return;
    }
    window.open(trackerUrl, "_blank");
  };

  // driver icon Rotation
  const calculateBearing = (start, end) => {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const toDeg = (rad) => (rad * 180) / Math.PI;

    const lat1 = toRad(start[0]);
    const lon1 = toRad(start[1]);
    const lat2 = toRad(end[0]);
    const lon2 = toRad(end[1]);

    const dLon = lon2 - lon1;

    const y = Math.sin(dLon) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

    return (toDeg(Math.atan2(y, x)) + 360) % 360;
  };

  useEffect(() => {
    if (!driverPosition) return;

    if (prevPositionRef.current) {
      const angle = calculateBearing(prevPositionRef.current, driverPosition);
      setRotation(angle);
    }

    prevPositionRef.current = driverPosition;
  }, [driverPosition]);

  // new driver position
  useEffect(() => {
    if (!driverPosition) return;

    setRoutePath((prev) => {
      if (
        prev.length &&
        prev[prev.length - 1][0] === driverPosition[0] &&
        prev[prev.length - 1][1] === driverPosition[1]
      ) {
        return prev;
      }

      return [...prev, driverPosition];
    });
  }, [driverPosition]);

  // distance calculation
  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // ETA calculation (avg speeed 25km/h)
  const [eta, setEta] = useState(null);

  useEffect(() => {
    if (!driverPosition) return;

    const distance = haversineDistance(
      driverPosition[0],
      driverPosition[1],
      homeLat,
      homeLng
    );

    const speed = 25; // km/h
    const timeMinutes = Math.round((distance / speed) * 60);

    setEta(timeMinutes);
  }, [driverPosition]);

  // Arrival detection
  const hasArrivedRef = useRef(false);

  useEffect(() => {
    if (!driverPosition || hasArrivedRef.current) return;

    const distance = haversineDistance(
      driverPosition[0],
      driverPosition[1],
      homeLat,
      homeLng
    );

    if (distance < 0.05) {
      hasArrivedRef.current = true;
      toast.success(" Your delivery partner has arrived!");
    }
  }, [driverPosition]);

  // const deliveryInstruction = {
  //   header: {
  //     icon: "note",
  //     title: "Delivery Instructions",
  //     subtitle: "Customer’s special instructions for the delivery partner",
  //   },

  //   sections: [
  //     {
  //       id: 1,
  //       icon: "shield",
  //       title: "Hand over to guard / watchman",
  //       description:
  //         "No need to come to the door. Please hand over the food to the security guard or watchman.",
  //     },
  //     {
  //       id: 2,
  //       icon: "bellOff",
  //       title: "Do not ring the doorbell",
  //       description:
  //         "Please do not ring the doorbell while delivering the order.",
  //     },
  //     {
  //       id: 3,
  //       icon: "phone",
  //       title: "Call before delivery",
  //       description:
  //         "Please call the customer once you reach the gate or nearby location.",
  //     },
  //     {
  //       id: 4,
  //       icon: "mapPin",
  //       title: "Deliver at main gate",
  //       description: "Complete the delivery at the society’s main gate only.",
  //     },
  //     {
  //       id: 5,
  //       icon: "clock",
  //       title: "Inform in case of delay",
  //       description:
  //         "If there is any delay, please inform the customer in advance.",
  //     },
  //   ],
  // };

  const deliveryDetails = {
    header: {
      title: "Your delivery details",
      subtitle: "Details of your current order",
      icon: "Bike",
    },
    sections: [
      {
        id: "address",
        title: orderDetails?.customer_name || "Delivery at Home",
        description: orderDetails?.customer_address || "Fetching address...",
        icon: "MapPin",
      },
      // {
      //   id: "contact",
      //   title: orderDetails?.customer_name
      //     ? `Name : ${orderDetails.customer_contact}`
      //     : "Phone",
      //   icon: "Phone",
      // },
    ],
  };

  /*  SCROLL LOGIC */
  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY;

      // Map auto expand/collapse ONLY if not manually expanded
      if (!manualExpand) {
        if (scrollY > 180) {
          setExpand(true);
        } else {
          setExpand(false);
        }
      }

      // HEADER logic – ALWAYS based on scroll
      if (scrollY > 180) {
        setShowStickyHeader(true);
      } else {
        setShowStickyHeader(false);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [manualExpand]);

  /*  CAROUSEL  */
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % loopedImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [loopedImages.length]);

  // const total = useMemo(
  //   () => products.reduce((sum, item) => sum + item.price * item.qty, 0),
  //   [products]
  // );

  const handleCopy = () => {
    navigator.clipboard.writeText(orderId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  /* LEAFLET */
  const pickupLat = orderDetails?.merchant_latitude
    ? Number(orderDetails.merchant_latitude)
    : null;

  const pickupLng = orderDetails?.merchant_longitude
    ? Number(orderDetails.merchant_longitude)
    : null;

  const homeLat = orderDetails?.customer_latitude
    ? Number(orderDetails.customer_latitude)
    : null;

  const homeLng = orderDetails?.customer_longitude
    ? Number(orderDetails.customer_longitude)
    : null;

  const driverLat = driverPosition?.[0];
  const driverLng = driverPosition?.[1];

  const bounds = useMemo(() => {
    const points = [];

    if (pickupLat && pickupLng) points.push([pickupLat, pickupLng]);
    if (driverLat && driverLng) points.push([driverLat, driverLng]);
    if (homeLat && homeLng) points.push([homeLat, homeLng]);

    return points.length ? points : [];
  }, [pickupLat, pickupLng, driverLat, driverLng, homeLat, homeLng]);

  // const mapCenter = [(homeLat + driverLat) / 2, (homeLng + driverLng) / 2];

  const homeIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
        <div style="
          width:38px;
          height:38px;
          background:#ffffff;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #e5e7eb;
        ">
          <img src="${home}" style="width:18px;height:18px;" />
        </div>
    `,
      iconSize: [34, 34],
      iconAnchor: [19, 56],
    });
  }, []);

  const restaurantIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
     <div style="
      display:flex;
      flex-direction:column;
      align-items:center;
    ">
      
      <!-- PIN BODY -->
      <div style="
        width:38px;
        height:38px;
        background:#ffffff;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        box-shadow:0 4px 10px rgba(0,0,0,0.25);
        border:1px solid #e5e7eb;
      ">
        <img 
          src="${resturant}" 
          style="width:18px;height:18px;"
        />
      </div>
    </div>
  `,
      iconSize: [34, 34],
      iconAnchor: [17, 34],
    });
  }, []);

  const driverIcon = useMemo(() => {
    return L.divIcon({
      className: "",
      html: `
      <img
        src="${deliveryman}"
        style="
          width:32px;
          height:32px;
          transform: rotate(${rotation}deg);
          transition: transform 0.6s linear;
        "
      />
    `,
      iconSize: [32, 32],
      iconAnchor: [16, 16],
    });
  }, [rotation]);

  useEffect(() => {
    if (!pickupLat || !pickupLng) return;

    setRoutePath([[pickupLat, pickupLng]]);
  }, [pickupLat, pickupLng]);

  useEffect(() => {
    if (!mapRef.current) return;

    const timeout = setTimeout(() => {
      mapRef.current.invalidateSize(true);
    }, 350);

    return () => clearTimeout(timeout);
  }, [expand]);

  // Button click handler
  const handleMapToggle = () => {
    setManualExpand(!expand);
    setExpand(!expand);
  };

  // signal R

const connectionRef = useRef(null);

useEffect(() => {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${baseurl}/notificationHub`, {
      accessTokenFactory: () => token,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connectionRef.current = connection;

  connection
    .start()
    .then(() => {
      // console.log("SignalR Connected");
    })
    .catch((err) => {
      console.error("SignalR Connection Error:", err);
    });

  //  STATUS UPDATES
  connection.on("ReceiveStatusUpdate", (data) => {
    // console.log("🔔 SignalR Update Received:", data);

    if (!Array.isArray(data)) return;

    data.forEach((item) => {
      // Match current task ID
      if (item.taskId === taskId) {
        // console.log("✅ Matched taskId:", taskId);
        
        // Show status update toast
        if (item.message) {
          toast.success(item.message);
        }

        // Update driver position immediately if coordinates available
        if (item.latitude && item.longitude) {
          const newPosition = [Number(item.latitude), Number(item.longitude)];
          // console.log("📍 New Driver Position:", newPosition);
          setDriverPosition(newPosition);
        }

        // Refresh complete data
        // console.log("🔄 Refreshing order & driver data");
        fetchDriver();
        fetchResturantDetails();
      }
    });
  });

  return () => {
    if (connectionRef.current) {
      connection.off("ReceiveStatusUpdate");
      connectionRef.current.stop();
      // console.log("SignalR Disconnected");
    }
  };
}, []);

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center">
      <div className="w-full max-w-md bg-orange-100 relative">
        {/* CAROUSEL */}
        <div className="w-full max-w-md mx-auto relative">
          <button
            onClick={() =>
              setIndex((prev) =>
                prev === 0 ? loopedImages.length - 1 : prev - 1
              )
            }
            className="absolute top-2 left-3 z-[1000] bg-white/90 backdrop-blur
             p-2 rounded-full shadow-md hover:bg-gray-100"
          >
            <ArrowLeft className="w-5 h-5 text-gray-700" />
          </button>
          <div className="overflow-hidden ">
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${index * 100}%)`,
              }}
            >
              {loopedImages.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`slide-${i}`}
                  className="w-full h-70 object-cover flex-shrink-0"
                />
              ))}
            </div>
          </div>
        </div>

        {/* STICKY HEADER  */}
        {showStickyHeader && (
          <div className="sticky top-0 z-[9999] bg-orange-500 text-white px-4 py-6 text-center shadow-lg">
            <p className="text-sm">Be ready to collect your order</p>
            <h2 className="text-xl font-semibold">Almost at your doorstep</h2>
          </div>
        )}

        {/* MAP SECTION */}
        <div
          className={`transition-all duration-500 relative z-10 
              ${
                expand ? "" : "mt-4 ml-4 mr-4 bg-white rounded-xl max-w-md mx-4"
              }
              ${expand && !manualExpand ? "mt-10 ml-4 mr-4" : " mt-4"}
            `}
        >
          {/* CONTENT - Only wrap in flex container when NOT expanded */}
          {!expand ? (
            <div className="flex items-center px-4 py-2">
              {/* LEFT TEXT (SMALL MAP) */}
              <div className="w-1/2 pr-3">
                <p className="text-xs text-gray-500 font-semibold">
                  Be ready to collect your order
                </p>
                <h2 className="text-lg mt-2 font-bold text-orange-600">
                  Almost at your doorstep
                </h2>
              </div>

              {/* MAP - SMALL */}
              <div className="relative overflow-hidden transition-all duration-500 rounded-xl w-1/2 h-28">
                <MapContainer
                  // center={mapCenter}
                  zoom={13}
                  className="h-full w-full rounded-xl"
                  dragging={false}
                  scrollWheelZoom={false}
                  zoomControl={false}
                  attributionControl={false}
                  whenCreated={(map) => (mapRef.current = map)}
                >
                  <MapResizer />
                  <FitBounds bounds={bounds} />
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {pickupLat && pickupLng && (
                    <Marker
                      position={[pickupLat, pickupLng]}
                      icon={restaurantIcon}
                    />
                  )}
                  {driverLat && driverLng && (
                    <Marker
                      position={[driverLat, driverLng]}
                      icon={driverIcon}
                      key={`${driverLat}-${driverLng}`}
                    />
                  )}
                  {homeLat && homeLng && (
                    <Marker position={[homeLat, homeLng]} icon={homeIcon} />
                  )}
                  {routePath.length > 1 && (
                    <Polyline
                      positions={routePath.filter(
                        (p) =>
                          typeof p[0] === "number" && typeof p[1] === "number"
                      )}
                      pathOptions={{
                        color: "#f97316",
                        weight: 4,
                        dashArray: "6 10",
                      }}
                    />
                  )}
                </MapContainer>

                <button
                  onClick={handleMapToggle}
                  className="absolute z-[500] bg-white p-2 rounded-full shadow-md hover:bg-gray-50 bottom-2 right-2"
                >
                  <Maximize2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ) : (
            /* MAP - EXPANDED - No wrapper, full width */
            <div className="relative overflow-hidden transition-all duration-500 rounded-xl w-full h-[38vh]">
              <MapContainer
                // center={mapCenter}
                zoom={15}
                className="h-full w-full rounded-xl"
                dragging={true}
                scrollWheelZoom={true}
                zoomControl={false}
                attributionControl={false}
                whenCreated={(map) => (mapRef.current = map)}
              >
                <MapResizer />
                <FitBounds bounds={bounds} />
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {pickupLat && pickupLng && (
                  <Marker
                    position={[pickupLat, pickupLng]}
                    icon={restaurantIcon}
                  />
                )}
                {driverLat && driverLng && (
                  <Marker
                    position={[driverLat, driverLng]}
                    icon={driverIcon}
                    key={`${driverLat}-${driverLng}`}
                  />
                )}
                {homeLat && homeLng && (
                  <Marker position={[homeLat, homeLng]} icon={homeIcon} />
                )}
                {routePath.length > 1 && (
                  <Polyline
                    positions={routePath.filter(
                      (p) =>
                        typeof p[0] === "number" && typeof p[1] === "number"
                    )}
                    pathOptions={{
                      color: "#f97316",
                      weight: 4,
                      dashArray: "6 10",
                    }}
                  />
                )}
              </MapContainer>

              <button
                onClick={handleMapToggle}
                className="absolute z-[500] bg-white p-2 rounded-full shadow-md hover:bg-gray-50 top-2 right-2"
              >
                <Minimize2 className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>

        {/* DELIVERY PARTNER */}
        <div className="bg-white max-w-md mt-4 rounded-xl shadow p-4 mx-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200">
              <img
                src={driverData.image}
                alt="Driver"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1">
              <p className="font-semibold">
                I'm {driverData.name}, your delivery partner
              </p>

              <p
                className={`text-sm transition-all duration-500 ${driverData.statusColor}`}
              >
                {driverData.message}
                {driverStatus === "successful" && (
                  <span className="ml-2 inline-block h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
                )}
              </p>

              {eta !== null &&
                driverStatus === "successful" &&
                !hasArrivedRef.current && (
                  <div className="flex items-center gap-1 mt-1 text-sm text-gray-600">
                    <Timer size={16} className="text-gray-500" />
                    <span>
                      Arriving in{" "}
                      <span className="font-semibold text-gray-800">
                        {eta} min
                      </span>
                    </span>
                  </div>
                )}

              {trackerUrl &&
                driverStatus === "successful" &&
                !hasArrivedRef.current && (
                  <button
                    onClick={openTracker}
                    className="mt-2 flex items-center gap-1 text-sm text-orange-600 font-semibold"
                  >
                    <MapPin size={16} />
                    Track Live
                  </button>
                )}
            </div>

            <a
              href={`tel:${driverData.phone}`}
              className="p-2 rounded-full border"
            >
              <Phone size={18} className="text-orange-600" />
            </a>
          </div>
        </div>

        {/* TIP SECTION */}
        {/* <div className="bg-white max-w-md mt-4 rounded-xl p-4">
          <h3 className="font-semibold mb-1">
            Delivering happiness at your doorstep!
          </h3>
          <p className="text-sm text-gray-500 mb-3">
            Thank them by leaving a tip
          </p>

          <div className="flex gap-3 overflow-x-auto">
            {["₹20", "₹30", "₹50", "Other"].map((tip) => (
              <button
                key={tip}
                className="min-w-[70px] px-4 py-2 rounded-full border text-sm font-medium hover:bg-orange-50 hover:border-orange-500"
              >
                {tip}
              </button>
            ))}
          </div>
        </div> */}

        {/* STORE DISTANCE */}
        <div className="bg-white max-w-md mt-4 mx-4 rounded-xl p-4">
          {/* Top Row */}
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-full bg-gray-100">
              <ShieldCheck className="w-6 h-6 text-green-500" />
            </div>

            <p className="text-sm text-gray-700 flex-1">
              Your Anlook store is <strong>700 mts away.</strong>
              <br />
              <span className="text-orange-600">
                Learn about delivery partner safety
              </span>
            </p>

            <button
              onClick={() => setShowSafety(!showSafety)}
              className="p-3 rounded-full ml-auto bg-gray-100"
            >
              {showSafety ? <ArrowDown size={18} /> : <ArrowRight size={18} />}
            </button>
          </div>

          {/* Safety Details */}
          {showSafety && (
            <div className="mt-4 bg-gray-50 rounded-lg p-3 text-sm text-gray-700">
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Delivery partners are verified & trained</span>
                </li>

                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Live order tracking available</span>
                </li>

                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Contactless delivery option</span>
                </li>

                <li className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-green-500 mt-[2px]" />
                  <span>Emergency support during delivery</span>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* DELIVERY INSTRUCTIONS */}

<div className="bg-white max-w-md mt-4 mx-4 rounded-xl p-4 flex items-start gap-3">
  <div className="p-2 rounded-full bg-gray-100">
    <Mic size={18} />
  </div>

  <div className="flex-1">
    <p className="font-semibold">Add delivery instructions</p>
    <p className="text-sm text-gray-500">
      Help your delivery partner reach you
    </p>
  </div>

  <button
    onClick={() => setInstructionOpen(!instructionOpen)}
    className="p-3 rounded-full bg-gray-100"
  >
    {instructionOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
  </button>
</div>

{/* DELIVERY INSTRUCTION BODY */}
{instructionOpen && deliveryInstruction && (
  <div className="bg-white max-w-md mt-2 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
    <div className="flex items-start gap-4">
      <div className="p-3 rounded-full bg-gray-100">
        {iconMap[deliveryInstruction.header.icon]}
      </div>
      <div>
        <p className="font-semibold">
          {deliveryInstruction.header.title}
        </p>
        <p className="text-sm text-gray-500">
          {deliveryInstruction.header.subtitle}
        </p>
      </div>
    </div>

    <hr />

    {deliveryInstruction.sections.map((item, index) => (
      <div key={item.id}>
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-full bg-gray-100">
            {iconMap[item.icon]}
          </div>
          <div>
            <p className="font-semibold">{item.title}</p>
            {item.description && (
              <p className="text-sm text-gray-600">
                {item.description}
              </p>
            )}
          </div>
        </div>

        {index !== deliveryInstruction.sections.length - 1 && (
          <hr className="mt-4" />
        )}
      </div>
    ))}
  </div>
)}



        {/* DELIVERY Details */}
        <div className="bg-white max-w-md mt-2 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
          {/* HEADER */}
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-full bg-gray-100">
              {iconMap[deliveryDetails.header.icon]}
            </div>
            <div>
              <p className="font-semibold">{deliveryDetails.header.title}</p>
              <p className="text-sm text-gray-500">
                {deliveryDetails.header.subtitle}
              </p>
            </div>
          </div>

          <hr />

          {/* SECTIONS */}
          {deliveryDetails.sections.map((item, index) => (
            <div key={item.id}>
              <div className="flex items-start gap-3">
                <div className="p-2 rounded-full bg-gray-100">
                  {iconMap[item.icon]}
                </div>
                <div>
                  <p className="font-semibold">{item.title}</p>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
              </div>

              {index !== deliveryDetails.sections.length - 1 && (
                <hr className="mt-4" />
              )}
            </div>
          ))}
        </div>

        {/* need help */}
        <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl shadow p-4">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-full bg-gray-100">
              <HelpCircle size={18} />
            </div>

            <div>
              <p className="font-semibold mb-1">Need help?</p>
              <p className="text-sm text-gray-500 mb-2">
                chat with us about any issue related to your order
              </p>
            </div>
            <button className="p-3 rounded-full ml-auto bg-gray-100">
              <ArrowRight size={18} />
            </button>
          </div>
        </div>

        {/* order summary */}
        <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-full bg-gray-100">
              <ClipboardList size={18} />
            </div>

            <div className="flex-1">
              <p className="font-semibold">Order Summary</p>

              <div className="flex items-center gap-2 mt-1">
                <p className="text-sm text-gray-500">Order ID: {orderId}</p>

                <button
                  onClick={handleCopy}
                  className="p-1 rounded hover:bg-gray-100"
                >
                  {copied ? (
                    <Check size={16} className="text-orange-600" />
                  ) : (
                    <Copy size={16} className="text-gray-600" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* VIEW BUTTON */}
          <button
            onClick={() => setOpen(!open)}
            className="w-full flex items-center justify-center px-4 py-3 gap-2 rounded-lg border text-sm font-medium hover:bg-gray-50"
          >
            <span>View Order Summary</span>
            {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </button>

          {open && (
            <div className="space-y-4">
              {/* PRODUCTS */}
              <div className="space-y-3">
                {products.map((item) => (
  <div key={item.id} className="flex items-center gap-3">
    <img
      src={item.image}
      alt={item.name}
      className="w-14 h-14 rounded-lg border object-cover"
    />

    <div className="flex-1">
      <p className="text-sm font-medium">{item.name}</p>
      <p className="text-xs text-gray-500">Qty: {item.qty}</p>
    </div>

    <p className="text-sm font-semibold">
      ₹{item.price * item.qty}
    </p>
  </div>
))}

              </div>

              <hr />

              {/* PAYMENT DETAILS */}
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Item total</span>
                  <span>₹{total}</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery charge</span>
                  <span className="text-orange-600">FREE</span>
                </div>
                <div className="flex justify-between font-semibold">
                  <span>Paid via UPI</span>
                  <span>₹{total}</span>
                </div>
              </div>

              <hr />

              <div className="text-sm text-orange-600 font-medium">
                Payment successful • Order confirmed
              </div>
            </div>
          )}
        </div>

        {/* like service */}
        <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl p-4 pb-0">
          <div className="flex items-start gap-4 mb-4">
            <div className="p-3 rounded-full bg-gray-100">
              <ThumbsUp size={18} />
            </div>

            <div>
              <p className="font-semibold mb-1">Do you like Our Service?</p>
              <p className="text-sm text-gray-500">
                Do rate us on the Play Store if you are enjoying our service.
                you can rate again if you have already rated us.
              </p>
            </div>
          </div>

          <div className="-mx-4 bg-gray-100 pt-[3px] flex gap-[3px]">
            <button className="w-1/2 py-3 text-sm text-orange-500 font-medium bg-white rounded-bl-xl">
              May be later
            </button>

            <button className="w-1/2 py-3 text-sm text-orange-500 font-medium bg-white rounded-br-xl">
              Rate Anlook
            </button>
          </div>
        </div>

        {/* up to date */}
        <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl p-4 pb-0">
          <div className="flex items-start gap-4 mb-4">
            <div className="p-3 rounded-full bg-gray-100">
              <Bell size={18} />
            </div>

            <div>
              <p className="font-semibold mb-1">Want to stay up-to-date?</p>
              <p className="text-sm text-gray-500">
                Enable notification so that we can notify you about your order
                and amazing offers.
              </p>
            </div>
          </div>

          <div className="flex gap-3 bg-gray-100 -mx-4 pt-[3px] ">
            <button className="w-full py-3 text-sm font-medium text-center text-orange-500 bg-white rounded-bl-xl rounded-br-xl">
              Enable
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
